module.exports = __webpack_public_path__ + "img/shape_10.aab10101.png";